import { ColumnDef } from '@tanstack/react-table'
import { Button } from 'components/ui/button'
import { Check, X, Loader2 } from 'lucide-react'
import moment from 'moment'
import type { PlayerRequestRow } from 'store/playersRequests/playersRequestsSlice'

export interface PlayersRequestsColumnsProps {
  onApprove: (requestId: number, notes: string) => void
  onReject: (requestId: number, notes: string) => void
}

export const playersRequestsColumns = (
  props: PlayersRequestsColumnsProps
): ColumnDef<PlayerRequestRow>[] => [
  {
    accessorKey: 'id',
    header: 'ID',
    cell: (info) => (
      <div className='text-center'>{String(info.getValue())}</div>
    ),
  },
  {
    accessorFn: (row) => row.user.name || '-',
    header: 'Utente',
  },
  {
    accessorFn: (row) => row.fit_player_profile.name || '-',
    header: 'Giocatore',
  },
  {
    accessorFn: (row) => row.fit_player_id ?? '-',
    header: 'Tessera',
  },
  {
    accessorFn: (row) => row.created_at,
    header: 'Data richiesta',
    cell: ({ row }) =>
      moment.unix(row.original.created_at).format('DD/MM/YYYY HH:mm'),
  },
  {
    accessorKey: 'status',
    header: 'Stato',
    cell: ({ row }) => {
      const { status, approval_notes, rejectal_notes, id, loaders } =
        row.original
      const isLoading = loaders.approval

      const note = status === 'approved' ? approval_notes : rejectal_notes

      return (
        <div>
          {status === 'pending' && (
            <div className='uk-alert uk-alert-warning uk-text-center mb-2 py-1'>
              In attesa
            </div>
          )}
          {status === 'approved' && (
            <div className='uk-alert uk-alert-success uk-text-center mb-2 py-1'>
              Approvato
            </div>
          )}
          {status === 'rejected' && (
            <div className='uk-alert uk-alert-danger uk-text-center mb-2 py-1'>
              Rifiutato
            </div>
          )}

          {note && (
            <p className='mb-2 text-center text-xs italic'>Note: {note}</p>
          )}

          <div className='flex justify-between gap-2'>
            <Button
              size='sm'
              variant='outline'
              disabled={status === 'approved' || isLoading}
              onClick={() => {
                const notes = prompt('Motivazione Approvazione:')
                if (notes !== null) {
                  props.onApprove(id, notes)
                }
              }}
            >
              {isLoading ? <Loader2 className='animate-spin' /> : <Check />}
              Approva
            </Button>
            <Button
              size='sm'
              variant='destructive'
              disabled={status === 'rejected' || isLoading}
              onClick={() => {
                const notes = prompt('Motivazione Rifiuto:')
                if (notes !== null && notes !== '') {
                  props.onReject(id, notes)
                }
              }}
            >
              {isLoading ? <Loader2 className='animate-spin' /> : <X />}
              Rifiuta
            </Button>
          </div>
        </div>
      )
    },
  },
]
